module.exports = __webpack_public_path__ + "img/servicepro_login.c717f12c.png";